import {
    archiveAdGroupNegativeKeywordRenderer,
    archiveCampaignNegativeKeywordRenderer,
    negativeKeywordIdRenderer,
} from 'components/FieldRenderers/Renderers/negativeKeyword'
import {
    archiveNegativeKeyword,
    negativeKeywordCreatedDate,
    negativeKeywordId,
    negativeKeywordMatchType,
    negativeKeywordState,
} from 'configuration/fieldCreators/negativeKeyword'
import { NegativeKeyword, Field } from 'types'

export const campaignNegativeKeywordsTableColumnsConfig: Field<NegativeKeyword>[] =
    [
        negativeKeywordId({
            fixed: 'left',
            sorter: true,
            renderOptions: {
                render: (props) => negativeKeywordIdRenderer(props),
            },
        }),
        negativeKeywordCreatedDate(),
        negativeKeywordMatchType({ sorter: true }),
        negativeKeywordState(),
        archiveNegativeKeyword({
            renderOptions: {
                render: (props) =>
                    archiveCampaignNegativeKeywordRenderer(props),
            },
        }),
    ]

export const adGroupNegativeKeywordsTableColumnsConfig: Field<NegativeKeyword>[] =
    [
        negativeKeywordId({
            fixed: 'left',
            sorter: true,
            renderOptions: {
                render: (props) => negativeKeywordIdRenderer(props),
            },
        }),
        negativeKeywordCreatedDate(),
        negativeKeywordMatchType({ sorter: true }),
        negativeKeywordState(),
        archiveNegativeKeyword({
            renderOptions: {
                render: (props) => archiveAdGroupNegativeKeywordRenderer(props),
            },
        }),
    ]
